import { Item } from "./Item";
import { Box, Typography, useTheme } from "@mui/material";

export const Card = ({
  subtitle,
  content,
  theme: themeFromProps,
  justify,
  onClick,
  color,
}) => {
  const theme = useTheme();
  const subtitleAlignment = justify === "start" ? "flex-start" : "center";
  const subtitlePadding = justify === "start" ? "0 0.25rem" : "0";
  const isClickable = typeof onClick === "function";
  
  return (
    <Item
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
      >
        <Typography
          variant="body1"
          style={{
            marginBottom: theme.spacing(1),
            fontWeight: "lighter",
            alignSelf: subtitleAlignment,
            padding: subtitlePadding,
            color: theme.palette.primary.text2,
          }}
        >
          {subtitle}
        </Typography>
        <Typography
          variant="h5"
          style={{
            padding: "0 .5rem",
            color: color || theme.palette.primary.main,
            fontWeight: "bold",
            whiteSpace: "pre-line", // Allow newlines in the content
            cursor: isClickable ? "pointer" : "inherit",
          }}
          onClick={onClick || undefined}
          role={isClickable ? "button" : undefined}
          tabIndex={isClickable ? 0 : undefined}
        >
          {content}
        </Typography>
      </Box>
    </Item>
  );
};
